import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

export const auditAdapter = createEntityAdapter({
  selectId: (item) => item.name,
});

const initialState = auditAdapter.getInitialState({
  loading: false,
  error: null,
  selectedEngagement: null,
});

export const auditSlice = createSlice({
  name: 'audit',
  initialState,
  reducers: {
    setSelectedEngagement: (state, action) => {
      state.selectedEngagement = action.payload;
    },
  },
});

export const { setSelectedEngagement } = auditSlice.actions;
export default auditSlice.reducer;
